import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Consumer } from './portal-provider';

var portal = function portal(targetName) {
  var updaterName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'updateChild';
  var idName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  return function (PortalComponent) {
    var PortalCore = /*#__PURE__*/function (_Component) {
      _inherits(PortalCore, _Component);

      var _super = _createSuper(PortalCore);

      function PortalCore(props) {
        var _this;

        _classCallCheck(this, PortalCore);

        _this = _super.call(this, props);
        _this.state = {
          portalId: null
        };
        return _this;
      }

      _createClass(PortalCore, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          var id = this.props.portalConnector.addChild(targetName, null);
          this.setState({
            portalId: id
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unmounted = true;
          this.props.portalConnector.removeChild(this.state.portalId);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this,
              _objectSpread2;

          if (!this.state.portalId) return null;

          var props = _objectSpread(_objectSpread({}, this.props), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, updaterName, function (child) {
            if (_this2.unmounted) return;

            _this2.props.portalConnector.updateChild(_this2.state.portalId, child);
          }), _defineProperty(_objectSpread2, idName, this.state.portalId), _objectSpread2));

          return /*#__PURE__*/React.createElement(PortalComponent, props);
        }
      }]);

      return PortalCore;
    }(Component);

    var Portal = /*#__PURE__*/function (_Component2) {
      _inherits(Portal, _Component2);

      var _super2 = _createSuper(Portal);

      function Portal() {
        _classCallCheck(this, Portal);

        return _super2.apply(this, arguments);
      }

      _createClass(Portal, [{
        key: "render",
        value: function render() {
          var _this3 = this;

          return /*#__PURE__*/React.createElement(Consumer, null, function (portalConnector) {
            return /*#__PURE__*/React.createElement(PortalCore, _extends({}, _this3.props, {
              portalConnector: portalConnector
            }));
          });
        }
      }]);

      return Portal;
    }(Component);

    return Portal;
  };
};

export default portal;